import React, { Fragment } from 'react';
import HeaderPortal from 'components/layout/HeaderPortal';
import DocumentTypeListBrowser from './DocumentTypeListBrowser';
import PermissionCheck from 'components/common/PermissionCheck';
import { ADMIN_DOCUMENT_TYPES } from 'constants/rightsCodes';

const Route = () => {
  return (
    <Fragment>
      <HeaderPortal />
      <PermissionCheck authorizationCode={ADMIN_DOCUMENT_TYPES}>
        <DocumentTypeListBrowser />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {};

export default Route;
